export const PRICING_UNITS = [
  { value: "fixed", label: "Fixed price / event" },
  { value: "per_person", label: "Per person" },
  { value: "per_hour", label: "Per hour" },
  { value: "per_day", label: "Per day" },
  { value: "per_item", label: "Per item" },
  { value: "per_quantity", label: "Per quantity" },
  { value: "package", label: "Package price" },
  { value: "starting", label: "Starting price" },
];

export const PRICING_UNIT_SUFFIX = {
  per_person: "/ person", per_hour: "/ hour", per_day: "/ day",
  per_item: "/ item", per_quantity: "/ unit", package: "/ package", fixed: "", starting: "",
};

export const BOOKING_TYPES = [
  { value: "direct", label: "Direct booking (Book Now)", cta: "Book Now" },
  { value: "quote", label: "Custom quotation (Request a Quote)", cta: "Request a Quote" },
  { value: "approval", label: "Admin approval required", cta: "Request Booking" },
];

export const EVENT_TYPES = [
  "Wedding", "Birthday", "Anniversary", "Reunion", "Corporate Event",
  "School Event", "Sports Event", "Live Show", "Other",
];

export const SUGGESTED_CATEGORIES = [
  "Wedding Planning and Management", "Venue Decoration and Theming", "Catering and Hospitality",
  "Photography and Videography", "Artists, DJs and Live Entertainment", "Sound, Lighting and Production",
  "Corporate Events and Conferences", "Birthdays and Anniversaries", "School Events and Annual Functions",
  "Sports Events", "Reunions and Private Celebrations", "Transport, Accommodation and Guest Management",
];

export const SERVICE_STATUSES = {
  draft: { label: "Draft", cls: "bg-zinc-200 text-zinc-700" },
  published: { label: "Published", cls: "bg-emerald-100 text-emerald-800" },
  unpublished: { label: "Unpublished", cls: "bg-amber-100 text-amber-800" },
  archived: { label: "Archived", cls: "bg-rose-100 text-rose-700" },
};

export function formatINR(n) {
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(n) || 0);
}

export function serviceCover(svc) {
  if (svc.cover_image) return svc.cover_image;
  const g = (svc.gallery || []).find((m) => m.type !== "video");
  return g ? g.url : "";
}

export function priceLabel(svc) {
  const pb = svc.price_breakdown || {};
  const cta = (BOOKING_TYPES.find((b) => b.value === svc.booking_type) || {}).value;
  if (cta === "quote" || !svc.price) return "On request";
  const amount = pb.inclusive ? pb.total : pb.taxable;
  const prefix = svc.price_is_starting || svc.pricing_unit === "starting" ? "From " : "";
  const suffix = PRICING_UNIT_SUFFIX[svc.pricing_unit] || "";
  const tax = svc.gst_applicable ? (pb.inclusive ? " incl. GST" : " + GST") : "";
  return `${prefix}${formatINR(amount)}${suffix ? " " + suffix : ""}${tax}`;
}

export function embedUrl(url) {
  if (!url) return "";
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return "";
}
